import {
  ClientSubscriptionDetailBackOfficeDto,
  ClientSubscriptionRequestDto,
} from 'api/Trading-Accounts/Types/ClientSubscriptionDetailBackOfficeDto'

import { SubscriptionLevelType } from './SubscriptionLevelType'
import { SubscriptionRequestState } from './SubscriptionRequestState'
import { SubscriptionRequestTypeEnum } from './SubscriptionRequestTypeEnum'
import { SubscriptionTimeInForce } from './SubscriptionTimeInForce'

export const canRequestResubscription = (
  subscriptionRequest: ClientSubscriptionRequestDto | undefined
): boolean =>
  subscriptionRequest?.state.id === SubscriptionRequestState.Pending &&
  subscriptionRequest.type.id === SubscriptionRequestTypeEnum.CancelExistingSubscription

export const subscriptionLevelHasActiveSubscriptionRequest = (
  subscriptionDetail: ClientSubscriptionDetailBackOfficeDto
): boolean => {
  const detail = subscriptionDetail.subscription.details.find(
    (subDetail) => subDetail.level.id === subscriptionDetail.level.id
  )
  return !!detail?.activeSubscriptionRequest
}

export const canCancelRequest = (subscriptionRequest?: ClientSubscriptionRequestDto): boolean =>
  !!subscriptionRequest?.dueDate &&
  subscriptionRequest?.state?.id === SubscriptionRequestState.Pending &&
  subscriptionRequest?.subscriptionTimeInForce.id !== SubscriptionTimeInForce.Immediate

const hasLevelTwoActiveSubscription = (
  subscriptionDetail: ClientSubscriptionDetailBackOfficeDto
): boolean => {
  const level2 = subscriptionDetail.subscription.details.find(
    (detail) => detail.level.id === SubscriptionLevelType.Level2
  )
  return !!level2?.activeSubscriptionRequest
}

const hasLevelOneActiveSubscription = (
  subscriptionDetail: ClientSubscriptionDetailBackOfficeDto
): boolean => {
  const level1 = subscriptionDetail.subscription.details.find(
    (detail) => detail.level.id === SubscriptionLevelType.Level1
  )
  return !!level1?.activeSubscriptionRequest
}
export const canRequestUpgrade = (
  subscriptionDetail: ClientSubscriptionDetailBackOfficeDto
): boolean => {
  return (
    subscriptionDetail.level.id === SubscriptionLevelType.Level2 &&
    hasLevelOneActiveSubscription(subscriptionDetail)
  )
}

export const canRequestDowngrade = (
  subscriptionDetail: ClientSubscriptionDetailBackOfficeDto
): boolean => {
  return (
    subscriptionDetail.level.id === SubscriptionLevelType.Level1 &&
    hasLevelTwoActiveSubscription(subscriptionDetail)
  )
}

export const isSubscriptionImmediateAndPending = (
  subscriptionRequest: ClientSubscriptionRequestDto | null
): boolean => {
  const isSubscriptionRequestImmediate = isSubscriptionTimeInForceImmediate(subscriptionRequest)
  return (
    isSubscriptionRequestImmediate &&
    subscriptionRequest?.state.id === SubscriptionRequestState.Pending
  )
}

export const isSubscriptionTimeInForceImmediate = (
  subscriptionRequest?: ClientSubscriptionRequestDto | null
): boolean => {
  return subscriptionRequest?.subscriptionTimeInForce?.id === SubscriptionTimeInForce.Immediate
}

export const isSubscriptionDeductingFundOrInProcess = (
  subscriptionRequest: ClientSubscriptionRequestDto | null
): boolean =>
  subscriptionRequest?.state.id === SubscriptionRequestState.DeductingFunds ||
  subscriptionRequest?.state.id === SubscriptionRequestState.InProcess
